import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import {
  PrevBtn,
  NextBtn,
  PaginationWrapper,
} from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import  { PaginationLimit } from "../../Config";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../Tooltip";


const Table = ({
  apiData,
  
}) => {
  const [data, setData] = useState([]);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const storageKey = `commission_page_index`;
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);


  const ActionBtns = () => (
    <div className="flex items-center gap-3">
      <Tooltip label="Tenant Details">
        <button
          className="text-gray-400 hover:text-gray-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdOutlineChevronRight size={22} />
        </button>
      </Tooltip>
    </div>
  );

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: item?.belongsToName,
        inventories: item?.inventoryName,
        rent: item?.amount,
        dues: item?.deposit,
        expiryDate: item.createdAt,
        action: ActionBtns(item),
      }));

      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Name", accessor: "name" },
        { Header: "Dues", accessor: "dues" },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Inventories",
        accessor: "inventories",
      },
      {
        Header: "Rent",
        accessor: "rent",
      },
      {
        Header: "Dues",
        accessor: "dues",
      },
      {
        Header: "Expiry Date",
        accessor: "expiryDate"
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                        //  onClick={() => {
                        //    if (
                        //      cellIndex === 0 ||
                        //      (cellIndex === 1 && window.innerWidth < 768)
                        //    ) {
                        //      toggleRow(rowIndex);
                        //    }
                        //  }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page {pageIndex + 1} of {pageOptions.length}
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="prev" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="next"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;

export default Table;















// import React, { useEffect, useState } from "react";
// import { useTable, useSortBy, usePagination } from "react-table";
// import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
// import Images from "../../Images";
// import tw from "tailwind-styled-components";
// import moment from "moment";
// import Config, { PaginationLimit } from "../../Config";
// import { useNavigate } from "react-router-dom";
// import { MdOutlineChevronRight } from "react-icons/md";
// import { MdAutorenew } from "react-icons/md";
// import { truncateText } from "../../helpers";
// import { FaFileAlt } from "react-icons/fa";
// import Tooltip from "../Tooltip";
// import TenantMiniProfile from "../Common/TenantMiniProfile";

// const Table = ({
//   apiData,
//   setSelectedData,
//   setIsRenewAgreement,
//   setIsViewNotes,
// }) => {
//   const storageKey = `tenant_expiring_page`;
//   const [data, setData] = useState([
//     {
//       deviceName: "",
//       extractionTime: "",
//       processingTime: "",
//       drops: "",
//       action: "",
//     },
//   ]);
//   const navigate = useNavigate();
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
//   const [previousId, setPreviousId] = useState(null);
//   //const [currentPage, setCurrentPage] = useState(0);
//   const [openActionMenu, setOpenActionMenu] = useState(null);
//   const toggleRow = (index) => {
//     setSelectedRow(selectedRow === index ? null : index);
//   };

//   const storageValue = sessionStorage.getItem(storageKey);
//   const savedPage = storageValue !== null ? Number(storageValue) : 0;
//   const [currentPage, setCurrentPage] = useState(savedPage);

//   useEffect(() => {
//     setCurrentPage(savedPage);
//   }, [savedPage]);

//   const renewAgreement = (item) => {
//     setIsRenewAgreement(true);
//     setSelectedData(item);
//     setOpenActionMenu(null);
//   };

//   const notes = (item) => {
//     setIsViewNotes(true);
//     setSelectedData(item);
//     setOpenActionMenu(null);
//   };

//   // const ActionBtns = (item) => {
//   //   return (
//   //     <div className="flex gap-4 ">
//   //       <button
//   //         onClick={() => goToDues('Tenant Info', item)}
//   //         className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
//   //       >
//   //         {/* Edit */}
//   //         <MdOutlineChevronRight className="text-gray-300" size={24} />
//   //       </button>
//   //     </div>
//   //   );
//   // };

//   const ActionBtns = (item) => (
//     <div className="flex items-center gap-3">
//       <Tooltip label="Click to view and add notes">
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             notes(item);
//           }}
//           className="text-gray-400 hover:text-blue-600 transition"
//         >
//           <FaFileAlt size={16} />
//         </button>
//       </Tooltip>
//       <Tooltip label="View tenant details">
//         <button
//           onClick={() => goToDues("Tenant Info", item)}
//           className="text-gray-400 hover:text-gray-700 transition"
//         >
//           <MdOutlineChevronRight size={22} />
//         </button>
//       </Tooltip>
//     </div>
//   );


//   useEffect(() => {
//     if (apiData) {
//       const tempData = apiData.map((item) => ({
//         name: getName(item),
//         //getProperty: getProperty(item),
//         rent: <span class="text-gray-600 text-sm flex">{'₹' + item.rent}</span>,
//         dues: getDues(item),
//         roomNum: getBedsFloors(item),
//         expiryDate: item.agreementExpiry ? showExpiryData(item) : '-',
//         moveInOutDate: moveInOutDate(item),
//         status: combineStatusAndKyc(item),
//         action: ActionBtns(item),
//       }));
//       setData(tempData);
//     }
//   }, [apiData, openActionMenu]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         !event.target.closest("#menuOptions") &&
//         !event.target.closest(".action-btn")
//       ) {
//         setOpenActionMenu(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const getName = (item) => {
//     return <TenantMiniProfile
//       tenantId={item.tenantId}
//       name={item.tenantName}
//       mobile={item.tenantMobile}
//       profilePicture={item.profilePicture}
//       kycStatus={item.kycStatus}
//       flatName={`${item.roomNum}, ${item.flatName}, ${item.propName}`}
//     />
//   };


//   // const getName = (item) => {
//   //   const name = capitalizeFirstLetter(item?.tenantName);
//   //   return (
//   //     <UserImageWrapper onClick={() => goToDues('Tenant Info', item)}>
//   //       <div className="flex-row flex">
//   //         <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.tenantName}`} />
//   //         {(item.kycStatus === 5 || item.kycStatus === 4) &&
//   //           <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
//   //             <FaCheck className="text-white" size={10} />
//   //           </div>
//   //         }
//   //       </div>
//   //       <div className="flex flex-col gap-1 max-w-36">
//   //         <span className="text-gray-600 text-sm font-medium line-clamp-2 block break-words overflow-hidden">
//   //           {/* {truncateText(name, 15)}{""} */}
//   //           {name}
//   //         </span>
//   //         {/* <span className="text-gray-600 text-xs">#{item.tenantMobile}</span> */}
//   //         <div className="flex gap-1">
//   //           <span className="text-gray-400 text-xs">#{item.tenantMobile}</span>
//   //           <button onClick={(e) => {
//   //             e.stopPropagation();
//   //             handleCopy(item.tenantMobile);
//   //           }}>
//   //             <IoCopySharp size={10} className="text-gray-400" />
//   //           </button>
//   //         </div>
//   //       </div>
//   //     </UserImageWrapper>
//   //   );
//   // };

//   const getStatus = (status) => {
//     if (status === 1) {
//       return <Unverified>Unverified</Unverified>;
//     } else if (status === 2) {
//       return <Vaccines>Vacant</Vaccines>;
//     } else if (status === 3) {
//       return <Linked>Linked</Linked>;
//     } else if (status === 4) {
//       return <Requested>Requested</Requested>;
//     } else if (status === 5) {
//       return <Occupied>Occupied</Occupied>;
//     } else if (status === 6) {
//       return <Moving>Moving Out</Moving>;
//     } else if (status === 7) {
//       return <Reserved>Reserved</Reserved>;
//     }
//   };

//   const combineStatusAndKyc = (item) => {
//     const statusElement = getStatus(item.status);
//     //const kycElement = getKycStatus(item.kycStatus);
//     return (
//       <div className="flex gap-1 cursor-pointer" onClick={() => goToDues('Tenant Info', item)}>
//         <span>{statusElement}</span>
//         {/* <span>{kycElement}</span> */}
//       </div>
//     );
//   };

//   const goToDues = (clickOn, item) => {
//     navigate(`/tenantdetails/l/${item.tenantId}`, {
//       state: {
//         tabName: clickOn,
//         tabKey: "totalDues",
//       },
//     });
//   };

//   const getDues = (item) => {
//     if (Number(item?.totalDues) === 0) {
//       return (
//         <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
//           No dues
//         </span>
//       );
//     }

//     return <Amount>₹{item?.totalDues}</Amount>;
//   };

//   // const getDues = (item) => {
//   //   return (
//   //     <div className="flex items-center gap-2" onClick={() => notes(item)}>
//   //       <Tooltip label="Click to view and add notes">
//   //         <span className="text-gray-600 flex text-sm cursor-pointer bg-neutral-100 px-3 py-1 rounded-md inline-flex"
//   //         // onClick={() => goToDues('Passbook', item)}
//   //         >
//   //           {"₹" + (item?.totalDues || 0)}
//   //         </span>
//   //       </Tooltip>
//   //       {/* <button title="Notes" onClick={() => notes(item)}>
//   //         <FaFileAlt className="text-gray-600 " size={14} />
//   //       </button> */}
//   //     </div>
//   //   );
//   // };

//   const showExpiryData = (item) => {
//     const daysLeft = moment(item.agreementExpiry).diff(moment(), "days");

//     const urgencyStyle =
//       daysLeft <= 15
//         ? "bg-red-50 text-red-700"
//         : daysLeft <= 30
//           ? "bg-amber-50 text-amber-700"
//           : "bg-slate-100 text-gray-700";

//     return (
//       <div className="flex items-center gap-2">
//         <span
//           className={`${urgencyStyle} px-3 py-1 rounded-full text-sm font-medium`}
//         >
//           {moment(item.agreementExpiry).format("DD, MMM YYYY")}
//         </span>

//         <button
//           onClick={() => renewAgreement(item)}
//           title="Renew Agreement"
//           className="text-gray-500 hover:text-gray-800 transition"
//         >
//           <MdAutorenew size={18} />
//         </button>
//       </div>
//     );
//   };


//   // const showExpiryData = (item) => {
//   //   return (
//   //     <span className={`text-gray-600 px-3 py-1 text-sm font-semibold cursor-pointer flex`}>
//   //       {(moment(item.agreementExpiry).format('DD, MMM YYYY'))} <button onClick={() => renewAgreement(item)}><MdAutorenew className="text-gray-600 ml-2" size={20} /></button>
//   //     </span>
//   //   );
//   // };

//   const getBedsFloors = (item) => (
//     <span
//       className="text-sm text-gray-600 truncate cursor-pointer"
//       title={item.propName}
//       onClick={() => goToDues("Tenant Info", item)}
//     >
//       {truncateText(item.propName, 28)}
//     </span>
//   );

//   const getBedsFloorsOld = (item) => {
//     return (
//       <span className={`text-gray-600 text-sm cursor-pointer`} onClick={() => goToDues('Tenant Info', item)}>
//         {/* {'#' + item?.roomNum + ", " + item?.flatName} */}
//         {truncateText(item.propName, 25)}
//       </span>
//     );
//   };
//   const moveInOutDate = (item) => {
//     return (
//       <div className="flex gap-3 ">
//         <div className="flex flex-col ">
//           <span>
//             {item.moveInDate
//               ? moment(item.moveInDate).format("DD, MMM YY")
//               : "---"}
//           </span>
//           <span className="text-gray-400 font-medium text-xs">M.In Date</span>
//         </div>
//         <div className="flex flex-col">
//           <span>
//             {item.agreementExpiry
//               ? moment(item.agreementExpiry).format("DD, MMM YY")
//               : "---"}
//           </span>
//           <span className="text-gray-400 font-medium text-xs">Expiry Date</span>
//         </div>
//       </div>
//     );
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const columns = React.useMemo(() => {
//     if (isMobileView) {
//       // Display only "User" column for mobile screens
//       return [
//         {
//           Header: "Name",
//           accessor: "name",
//         },
//         {
//           Header: "Property",
//           accessor: "roomNum",
//         },
//       ];
//     }
//     return [
//       {
//         Header: "Name",
//         accessor: "name",
//       },
//       {
//         Header: "Property",
//         accessor: "roomNum",
//       },
//       {
//         Header: "Rent",
//         accessor: "rent",
//       },
//       // {
//       //   Header: "Move In/Expiry",
//       //   accessor: "moveInOutDate",
//       // },
//       {
//         Header: "Dues",
//         accessor: "dues",
//       },
//       {
//         Header: "Expiry Date",
//         accessor: "expiryDate",
//       },
//       // {
//       //   Header: "Status",
//       //   accessor: "status",
//       // },

//       {
//         Header: "",
//         accessor: "action",
//       },
//     ];
//   }, [isMobileView]);
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     pageOptions,
//     page,
//     state: { pageIndex, pageSize },
//     previousPage,
//     nextPage,
//     setPageSize,
//     canPreviousPage,
//     canNextPage,
//   } = useTable(
//     {
//       data,
//       columns,
//       initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
//     },
//     useSortBy,
//     usePagination
//   );

//   // useEffect(() => {
//   //   setPageSize(PaginationLimit);
//   // }, []);
//   useEffect(() => {
//     //setCurrentPage(pageIndex); // Update current page on state change
//     sessionStorage.setItem(storageKey, pageIndex);
//   }, [pageIndex, storageKey]);

//   return (
//     <>
//       <CustomTable {...getTableProps()}>
//         <Thead>
//           {headerGroups.map((headerGroup) => (
//             <Tr {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map((column) => (
//                 <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
//                   {column.render("Header")}
//                   <span>
//                     {column.isSorted ? (
//                       <img
//                         src={Images.Arrow}
//                         alt="down arrow"
//                         className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
//                           } w-1.5 inline-block ml-1.5`}
//                       />
//                     ) : (
//                       ""
//                     )}
//                   </span>
//                 </Th>
//               ))}
//             </Tr>
//           ))}
//         </Thead>
//         <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
//           {page.map((row, rowIndex) => {
//             prepareRow(row);
//             const rowData = apiData[rowIndex];
//             return (
//               <React.Fragment key={rowIndex}>
//                 <Tr
//                   {...row.getRowProps({ style: { height: "80px" } })}
//                   hasdata={(apiData?.length > 0).toString()}
//                 // onClick={() =>
//                 //   navigate(`/tenantdetails/${rowData.tenantId}`, {
//                 //     state: { data: rowData },
//                 //   })
//                 // }
//                 //style={{ cursor: "pointer" }}
//                 >
//                   {row.cells.map((cell, cellIndex) => {
//                     const isActionCell = cell.column.id === "action";
//                     return (
//                       <Td
//                         {...cell.getCellProps()}
//                       // onClick={(event) => {
//                       //   // Prevent row click for action button
//                       //   if (isActionCell) event.stopPropagation();
//                       // }}
//                       // onClick={["name", "rent", "roomNum", "moveInOutDate", "status"].includes(cell.column.id) ? () => goToDues ('Tenant Info', cell) : null}

//                       >
//                         {cell.render("Cell")}
//                       </Td>
//                     );
//                   })}
//                 </Tr>
//                 {selectedRow === rowIndex && window.innerWidth < 768 && (
//                   <Tr>
//                     <Td colSpan={columns.length}>
//                       <ul className="flex flex-col gap-2">
//                         <li>
//                           <strong>Bed/Floor</strong>{" "}
//                           {data[rowIndex].roomNum}
//                         </li>
//                         <li>
//                           <strong>Agreement Duration</strong>{" "}
//                           {data[rowIndex].moveInOutDate}
//                         </li>
//                         <li>
//                           <strong>Bed/Floor</strong>{" "}
//                           {data[rowIndex].roomNum}
//                         </li>
//                         <li className="flex gap-2">
//                           <strong>Status/KYC Status</strong>{" "}
//                           {data[rowIndex].status}
//                         </li>
//                         <li>
//                           <strong>Action:</strong> {data[rowIndex].action}
//                         </li>
//                       </ul>
//                     </Td>
//                   </Tr>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </Tbody>
//       </CustomTable>
//       {apiData?.length > 0 && (
//         <PaginationWrapper>
//           <div className="px-2">
//             Page{" "}
//             <em>
//               {pageIndex + 1} of {pageOptions.length}
//             </em>
//           </div>

//           <div className="flex gap-1">
//             <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
//               <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
//             </PrevBtn>
//             <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
//               <img
//                 src={Images.Arrow}
//                 alt="arrow"
//                 className="w-2 rotate-180 opacity-75"
//               />
//             </NextBtn>
//           </div>
//         </PaginationWrapper>
//       )}

//     </>
//   );
// };

// const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
// const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-lg transform transition duration-200 hover:scale-110 hover:shadow-md`;
// const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// // const  ActionBtnWrapper = tw.div`
// //   flex flex-wrap items-center w-[110px] mb-1 gap-y-1 gap-x-1.5 mt-20 md:mt-0
// // `;
// const CustomTable = tw.table` w-full text-zinc-600`;
// const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
// const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
// const Tr = tw.tr`
//   border-b
//   hover:bg-slate-50
//   transition
// `;
// const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
// const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// // const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-lg transform transition duration-200 hover:scale-110 hover:shadow-md`;

// const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
// const UserImage = tw.img`w-10 h-10 rounded-full `;

// const IdUpload = tw.div`bg-green-100 text-green-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const Personal = tw.div`bg-orange-100 text-orange-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const Selfie = tw.div`bg-lime-100 text-lime-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const RentAgreement = tw.div`bg-teal-100 text-teal-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const Verification = tw.div`bg-yellow-100 text-yellow-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const KycPending = tw.div`bg-blue-100 text-blue-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
// const Unknown = tw.div`bg-zinc-100 text-zinc-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;

// const Unverified = tw.div`bg-yellow-50 text-yellow-700 text-xs border-yellow-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Vaccines = tw.div`bg-blue-50 text-blue-700 text-xs border-blue-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Requested = tw.div`bg-lime-50 text-lime-700 text-xs border-lime-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Occupied = tw.div`bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Reserved = tw.div`bg-orange-50 text-orange-700 text-xs border-orange-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Linked = tw.div`bg-purple-50 text-purple-700 text-xs border-purple-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// const Moving = tw.div`bg-rose-50 text-rose-700 text-xs border-rose-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
// //const Amount = tw.p`text-gray-600 text-sm flex`
// const Amount = tw.p`text-sm font-medium text-rose-700 bg-rose-100 px-3 py-1 rounded-full cursor-default hover:bg-rose-200 transition inline-flex`

// export default Table;




















// import React, { useState, useEffect } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   FaTachometerAlt,
//   FaUser,
//   FaBuilding,
//   FaCoins,
//   FaUserCheck,
//   FaUsers,
//   FaUserTie,
//   FaList,
//   FaFileContract,
//   FaUserSecret,
//   FaClock,
//   FaRegFileAlt,
//   FaBan,
//   FaPauseCircle,
//   FaUserClock 
// } from "react-icons/fa";
// import { FiUsers } from "react-icons/fi";

// import {
//   MdOutlineHeadsetMic,
//   MdSettings,
//   MdLogout,
//   MdMarkEmailRead,
//   MdMenu,
//   MdClose,
//   MdKeyboardArrowDown,
//   MdBolt
// } from "react-icons/md";
// import {
//   RiArrowDropDownLine,
//   RiFlashlightFill,
//   RiRefund2Fill,
// } from "react-icons/ri";

// import { HiOutlineMapPin } from "react-icons/hi2";

// import { GrAnnounce } from "react-icons/gr";
// import { FaFolderClosed, FaMoneyBillTrendUp, FaMoneyCheckDollar, FaPersonWalking } from "react-icons/fa6";
// import { BsBuildingGear } from "react-icons/bs";
// import { RxActivityLog } from "react-icons/rx";
// import { FaMoneyBillWave, FaHandshake } from "react-icons/fa";
// import { TbCalendarDue } from "react-icons/tb";
// import { IoAlarmOutline } from "react-icons/io5";
// import { SiPivotaltracker } from "react-icons/si";
// import Images from "../Images";
// import tw from "tailwind-styled-components";
// import { capitalizeFirstLetter, getRole, getUserType, hasPermission } from "../helpers";
// import Config from "../Config";
// import { IoMdLogOut } from "react-icons/io";
// import { LiaUserClockSolid } from "react-icons/lia";

// const SideNabar = ({ onLogoutClick }) => {
//   const navigate = useNavigate();
//   const { pathname } = useLocation();
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [isMobileOpen, setIsMobileOpen] = useState(false);
//   const [openSections, setOpenSections] = useState({
//     property: false,
//     // money: false,
//     // tenants: false,
//     // quickAction: false,
//     // landlords: false,
//   });
//   const user = useSelector((state) => state.UserReducer.user);

//   // const selectProperty = useSelector(
//   //   (state) => state.SelectPropertyReducer.selectProperty
//   // );
//   const storedPartner = useSelector((state) => state.SelectedPartnerReducer.selectPartner);
//   // const propId = selectProperty.id;
//   // const hasPermission = (userPermissions, bitIndex) =>
//   // (userPermissions & (1 << bitIndex)) !== 0;

//   useEffect(() => {
//     setIsMobileOpen(false);
//   }, [pathname]);

//   const resetTablePagination = () => {
//     // Add all your table keys here
//     sessionStorage.removeItem("tenant_active_page");
//     sessionStorage.removeItem("tenant_expiring_page");
//     sessionStorage.removeItem("tenant_movedout_page");
//     sessionStorage.removeItem("landlord_list_page");
//     sessionStorage.removeItem("dues_page");
//     sessionStorage.removeItem("collections_page");
//     sessionStorage.removeItem("expenses_page");
//     sessionStorage.removeItem("property_list_page");
//     // …add all other table keys used in your pages
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobileOpen && !event.target.closest('.sidebar-container') && !event.target.closest('.mobile-menu-button')) {
//         setIsMobileOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [isMobileOpen]);

//   useEffect(() => {
//     if (isMobileOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }

//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [isMobileOpen]);

//   // const handleInventoryNavigation = (e) => {
//   //   if (propId === 0) {
//   //     navigate("/inventory-list");
//   //   } else {
//   //     navigate("/inventory");
//   //   }
//   //   e.preventDefault();
//   // };

//   useEffect(() => {
//     const newOpenSections = {
//       property: false,
//       // money: false,
//       // tenants: false,
//       // quickAction: false,
//       // landlords: false,
//     };

//     if (pathname === '/inventory/operational' || pathname === '/inventory/details' || pathname === '/properties/agreements' || pathname === '/inventory/unavailable' || pathname === '/properties/lockin-tracker' || pathname === '/inventory' || pathname === '/properties/recurring-exp' || pathname === '/property-extra-charges' || pathname === '/electricity-bill' || pathname === '/landlord/property-list' || pathname === '/landlord/agreement') {
//       newOpenSections.property = true;
//     }
//     if (pathname === '/deals/pipeline' || pathname === '/deals/closed') {
//       newOpenSections.deals = true;
//     }
//     // else if (pathname === '/tenants/active' || pathname === '/tenants/expiring-agreements' || pathname === '/tenants/moved-out' || pathname === '/tenants/agreement' || pathname.includes("tenantdetails/l")) {
//     //       newOpenSections.tenants = true;
//     //     } else if (pathname === '/leads' || pathname === '/staffs' || pathname === '/notice' || pathname === '/extracharges' || pathname === '/vendors' || pathname === '/activity-logs' || pathname.includes("vendors-expense")) {
//     //       newOpenSections.quickAction = true;
//     //     } else if (pathname === '/landlords' || pathname === '/landlords/payments' || pathname === '/landlord/transactions' || pathname === '/landlord/pending-dues' || pathname === '/landlord/details') {
//     //       newOpenSections.landlords = true;
//     //     } else if (pathname === '/property-list' || pathname === '/property-detail' || pathname === '/properties/agreements' || pathname === '/properties/expiring-agreements' || pathname === '/properties/lockin-tracker' || pathname === '/inventory' || pathname === '/properties/recurring-exp' || pathname === '/property-extra-charges' || pathname === '/electricity-bill' || pathname === '/landlord/property-list' || pathname === '/landlord/agreement') {
//     //       newOpenSections.property = true;
//     //     }

//     setOpenSections(newOpenSections);
//   }, [pathname]);

//   const toggleSection = (section) => {
//     setOpenSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   const toggleSidebar = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   const toggleMobileSidebar = () => {
//     setIsMobileOpen(!isMobileOpen);
//   };

//   const isOwner =
//     user?.userType === Config.USER_TYPE.CLIENT ||
//     user?.role === Config.STAFF_ROLES.PARTNER;
//   const isAdmin =
//     user?.role === Config.STAFF_ROLES.ADMIN &&
//     user?.userType === Config.USER_TYPE.STAFF;
//   const isFinance =
//     user?.role === Config.STAFF_ROLES.FINANCEADMIN &&
//     user?.userType === Config.USER_TYPE.STAFF;
//   const isLandlord = user?.userType === 5;

//   const landlordMenuItems = [
//     // {
//     //   type: "link",
//     //   href: "/landlord/dashboard",
//     //   icon: FaTachometerAlt,
//     //   label: "Dashboard",
//     //   active: pathname === "/landlord/dashboard"
//     // },
//     // {
//     //   type: "dropdown",
//     //   key: "property",
//     //   icon: FaBuilding,
//     //   label: "Properties",
//     //   isOpen: openSections.property,
//     //   onToggle: () => toggleSection("property"),
//     //   items: [
//     //     {
//     //       href: "/landlord/property-list",
//     //       icon: FaList,
//     //       label: "List",
//     //       active: pathname === "/landlord/property-list"
//     //     },

//     //     {
//     //       href: "/landlord/agreement",
//     //       icon: FaFileContract,
//     //       label: "Agreement",
//     //       active: pathname === "/landlord/agreement"
//     //     },
//     //   ]
//     // },
//     // {
//     //   type: "link",
//     //   href: "/landlord/client",
//     //   icon: FaUser,
//     //   label: "Primary Tenants",
//     //   active: pathname === "/landlord/client"
//     // },
//     // {
//     //   type: "link",
//     //   href: "/landlord/dues",
//     //   icon: TbCalendarDue,
//     //   label: "Dues",
//     //   active: pathname === "/landlord/dues"
//     // },
//     // {
//     //   type: "link",
//     //   href: "/landlord/collections",
//     //   icon: FaCoins,
//     //   label: "Collection",
//     //   active: pathname === "/landlord/collections"
//     // },
//   ]

//   const regularMenuItems = [
//     // Dashboard
//     (isOwner || isAdmin || isFinance) && {
//       type: "link",
//       href: "/dashboard",
//       icon: FaTachometerAlt,
//       label: "Dashboard",
//       active: pathname === "/dashboard"
//     },
//     {
//       type: "dropdown",
//       key: "inventory",
//       icon: FaBuilding,
//       label: "Inventory",
//       isOpen: openSections.property,
//       onToggle: () => toggleSection("property"),
//       items: [
//         {
//           href: "/inventory/operational",
//           icon: FaList,
//           label: "Operational",
//           active: pathname === "/inventory/operational"
//         },
//         {
//           href: "/inventory/unavailable",
//           icon: FaPauseCircle,
//           label: "Unavailable",
//           active: pathname === "/properties/unavailable"
//         },
//         // {
//         //   href: "/properties/recurring-exp",
//         //   icon: SiPivotaltracker,
//         //   label: "Recurring Payables",
//         //   active: pathname === "/properties/recurring-exp"
//         // },
//       ]
//     },
//     // Inventory
//     // {
//     //   type: "link",
//     //   href: "/inventory/operational",
//     //   icon: FaBuilding,
//     //   label: "Inventory",
//     //   active: pathname === "/inventory/operational",
//     // },

//     {
//       type: "dropdown",
//       key: "deals",
//       icon: FaHandshake,
//       label: "Deals",
//       isOpen: openSections.deals,
//       onToggle: () => toggleSection("deals"),
//       items: [
//         {
//           href: "/deals/pipeline",
//           icon: FaList,
//           label: "Pipeline",
//           active: pathname === "/deals/pipeline"
//         },
//         {
//           href: "/deals/closed",
//           icon: FaFolderClosed,
//           label: "Closed", //Lost and Cancelled
//           active: pathname === "/deals/closed"
//         },
//       ]
//     },

//     {
//       type: "dropdown",
//       key: "agreement",
//       icon: FaUserClock,
//       label: "Agreement",
//       isOpen: openSections.agreement,
//       onToggle: () => toggleSection("agreement"),
//       items: [
//         {
//           href: "/tenants/agreement",
//           icon: IoAlarmOutline,
//           label: "Expiring Agreement",
//           active: pathname === "/tenants/agreement"
//         },
//       ]
//     },

//     // Deals
//     // {
//     //   type: "link",
//     //   href: "/deals/pipeline",
//     //   icon: FaHandshake,
//     //   label: "Deals",
//     //   active: pathname === "/deals/pipeline",
//     // },

//     // Owners
//     {
//       type: "link",
//       href: "/enquiries",
//       icon: FiUsers,
//       label: "Enquiries",
//       active: pathname === "/enquiries",
//     },

//     // Owners
//     {
//       type: "link",
//       href: "/owners",
//       icon: FaUserSecret,
//       label: "Owners",
//       active: pathname === "/owners",
//     },

//     // Staffs
//     {
//       type: "link",
//       href: "/staffs",
//       icon: FaUserTie,
//       label: "Staffs",
//       active: pathname === "/staffs",
//     },

//     // Brokers
//     {
//       type: "link",
//       href: "/brokers",
//       icon: FaUserTie,
//       label: "Brokers",
//       active: pathname === "/brokers",
//     },
//     // Revenue
//     {
//       type: "link",
//       href: "/revenue",
//       icon: FaCoins,
//       label: "Revenue",
//       active: pathname === "/revenue",
//     },

//     // Locations
//     {
//       type: "link",
//       href: "/locations",
//       icon: HiOutlineMapPin,
//       label: "Locations",
//       active: pathname === "/locations",
//     },

//     // Reports
//     {
//       type: "link",
//       href: "/reports",
//       icon: FaRegFileAlt,
//       label: "Reports",
//       active: pathname === "/reports",
//     },
//     // Properties with only List submenu
//     //     hasPermission("MANANGE_EXPENSES", user) ||
//     //       hasPermission("MANANGE_EXTRACHARGES", user) ||
//     //       hasPermission("MANANGE_INVENTORY", user)
//     //       ?
//     // {
//     //   type: "dropdown",
//     //   key: "property",
//     //   icon: FaBuilding,
//     //   label: "Properties",
//     //   isOpen: openSections.property,
//     //   onToggle: () => toggleSection("property"),
//     //   items: [
//     //     {
//     //       href: "/property-list",
//     //       icon: FaList,
//     //       label: "List",
//     //       active: pathname === "/property-list"
//     //     },
//     // All other property submenus commented out
//     // {
//     //   href: "/properties/agreements",
//     //   icon: FaFileContract,
//     //   label: "Agreements",
//     //   active: pathname === "/properties/agreements"
//     // },
//     // {
//     //   href: "/properties/recurring-exp",
//     //   icon: SiPivotaltracker,
//     //   label: "Recurring Payables",
//     //   active: pathname === "/properties/recurring-exp"
//     // },
//     //   ]
//     // },

//     // All other menu items commented out
//     // hasPermission("MANANGE_TENANTS", user) && {
//     //   type: "dropdown",
//     //   key: "tenants",
//     //   icon: FaUsers,
//     //   label: "Tenants",
//     //   isOpen: openSections.tenants,
//     //   onToggle: () => toggleSection("tenants"),
//     //   items: [
//     //     {
//     //       href: "/tenants/active",
//     //       icon: FaUserCheck,
//     //       label: "Active",
//     //       active: pathname === "/tenants/active"
//     //     },
//     //     {
//     //       href: "/tenants/agreement",
//     //       icon: IoAlarmOutline,
//     //       label: "Expiring Agreement",
//     //       active: pathname === "/tenants/agreement"
//     //     },
//     //     {
//     //       href: "/tenants/moved-out",
//     //       icon: FaPersonWalking,
//     //       label: "Moved Out",
//     //       active: pathname === "/tenants/moved-out"
//     //     },
//     //   ]
//     // },

//     // hasPermission("MANANGE_DUES", user) ||
//     //   hasPermission("MANANGE_COLLECTIONS", user) ||
//     //   hasPermission("MANANGE_EXPENSES", user)
//     //   ?
//     //   {
//     //     type: "dropdown",
//     //     key: "money",
//     //     icon: FaMoneyCheckDollar,
//     //     label: "Finance",
//     //     isOpen: openSections.money,
//     //     onToggle: () => toggleSection("money"),
//     //     items: [
//     //       hasPermission("MANANGE_DUES", user) && {
//     //         href: "/finance/dues",
//     //         icon: TbCalendarDue,
//     //         label: "Dues",
//     //         active: pathname === "/finance/dues"
//     //       },
//     //       hasPermission("MANANGE_COLLECTIONS", user) && {
//     //         href: "/finance/collections",
//     //         icon: FaCoins,
//     //         label: "Collection",
//     //         active: pathname === "/finance/collections"
//     //       },
//     //       hasPermission("MANANGE_EXPENSES", user) && {
//     //         href: "/finance/expenses",
//     //         icon: FaMoneyBillWave,
//     //         label: "Expenses",
//     //         active: pathname === "/finance/expenses"
//     //       },
//     //     ]
//     //   } : null,

//     // hasPermission("MANANGE_LANDLORD", user) && {
//     //   type: "dropdown",
//     //   key: "landlords",
//     //   icon: FaUserSecret,
//     //   label: "Landlords",
//     //   isOpen: openSections.landlords,
//     //   onToggle: () => toggleSection("landlords"),
//     //   items: [
//     //     {
//     //       href: "/landlords",
//     //       icon: FaList,
//     //       label: "List",
//     //       active: pathname === "/landlords"
//     //     },
//     //     {
//     //       href: "/landlords/payments",
//     //       icon: FaCoins,
//     //       label: "Payments",
//     //       active: pathname === "/landlords/payments"
//     //     },
//     //     {
//     //       href: "/landlord/pending-dues",
//     //       icon: FaClock,
//     //       label: "Pending Dues",
//     //       active: pathname === "/landlord/pending-dues"
//     //     }
//     //   ]
//     // },

//     // hasPermission("MANANGE_REQUESTS", user) && {
//     //   type: "link",
//     //   href: "/requests",
//     //   icon: MdMarkEmailRead,
//     //   label: "Request",
//     //   active: pathname === "/requests"
//     // },

//     // hasPermission("MANANGE_COMPLAINTS", user) && {
//     //   type: "link",
//     //   href: "/complaints",
//     //   icon: MdOutlineHeadsetMic,
//     //   label: "Complaints",
//     //   active: pathname === "/complaints"
//     // },

//     // (user.parentId === null && storedPartner?.clientId === user.id) && {
//     //   type: "link",
//     //   href: "/partners",
//     //   icon: FaHandshake,
//     //   label: "Partners",
//     //   active: pathname === "/partners"
//     // },

//     // {
//     //   type: "dropdown",
//     //   key: "quickAction",
//     //   icon: RiFlashlightFill,
//     //   label: "Quick Action",
//     //   isOpen: openSections.quickAction,
//     //   onToggle: () => toggleSection("quickAction"),
//     //   items: [
//     //     hasPermission("MANANGE_LEADS", user) && {
//     //       href: "/leads",
//     //       icon: FaUser,
//     //       label: "Leads",
//     //       active: pathname === "/leads"
//     //     },
//     //     hasPermission("MANANGE_STAFF", user) && {
//     //       href: "/staffs",
//     //       icon: FaUserTie,
//     //       label: "Staffs",
//     //       active: pathname === "/staffs"
//     //     },
//     //     hasPermission("MANANGE_STAFF", user) && {
//     //       href: "/vendors",
//     //       icon: FaUser,
//     //       label: "Vendors",
//     //       active: pathname === "/vendors"
//     //     },
//     //     hasPermission("MANANGE_TENANTS", user) && {
//     //       href: "/activity-logs",
//     //       icon: RxActivityLog,
//     //       label: "Activity Logs",
//     //       active: pathname === "/activity-logs"
//     //     },
//     //     hasPermission("MANANGE_EXTRACHARGES", user) && {
//     //       href: "/extracharges",
//     //       icon: FaMoneyBillTrendUp,
//     //       label: "Extra Charges",
//     //       active: pathname === "/extracharges"
//     //     },
//     //   ]
//     // },

//     // hasPermission("MANANGE_PROPERTY_ASSETS", user) && {
//     //   type: "link",
//     //   href: "/assets",
//     //   icon: BsBuildingGear,
//     //   label: "Asset Management",
//     //   active: pathname === "/assets"
//     // },

//     // (isOwner || isAdmin) && {
//     //   type: "link",
//     //   href: "/settings",
//     //   icon: MdSettings,
//     //   label: "Settings",
//     //   active: pathname === "/settings"
//     // },

//   ];

//   const menuItems = isLandlord ? landlordMenuItems : regularMenuItems;

//   const cleanMenu = (menus) => {
//     return menus
//       .filter(Boolean) // remove false, null, undefined
//       .map((item) => {
//         if (item.type === "dropdown" && Array.isArray(item.items)) {
//           return {
//             ...item,
//             items: cleanMenu(item.items), // recursively clean submenus
//           };
//         }
//         return item;
//       });
//   };

//   const safeMenuItems = cleanMenu(menuItems);

//   const MenuButton = ({ children, isActive, onClick, asLink = false, href = "#", className = "" }) => {
//     if (asLink) {
//       return (
//         <MenuLink
//           to={href}
//           $isActive={isActive}
//           className={className}
//         // onClick={() => {
//         //   resetTablePagination();   // RESET page indexes on navigation
//         // }}
//         >
//           {children}
//         </MenuLink>
//       );
//     }

//     return (
//       <MenuButtonWrapper
//         onClick={onClick}
//         $isActive={isActive}
//         className={className}
//       >
//         {children}
//       </MenuButtonWrapper>
//     );
//   };

//   const renderMenuItem = (item) => {
//     if (item.type === "link") {
//       return (
//         <li key={item.href}>
//           <MenuButton
//             asLink
//             href={item.href}
//             isActive={item.active}
//           >
//             <item.icon className="h-4 w-4 flex-shrink-0" />
//             <MenuItemLabel
//               $isCollapsed={isCollapsed}
//               $isMobileOpen={isMobileOpen}
//             >
//               {item.label}
//             </MenuItemLabel>
//           </MenuButton>
//         </li>
//       );
//     }

//     if (item.type === "dropdown") {
//       return (
//         <li key={item.key} className="mb-1">
//           <MenuButton
//             onClick={item.onToggle}
//             isActive={item.active}
//             className="justify-between"
//           >
//             <div className="flex items-center gap-3">
//               <item.icon className="h-4 w-4 flex-shrink-0" />
//               <MenuItemLabel
//                 $isCollapsed={isCollapsed}
//                 $isMobileOpen={isMobileOpen}
//               >
//                 {item.label}
//               </MenuItemLabel>
//             </div>
//             <DropdownIcon
//               $isOpen={item.isOpen}
//               $isCollapsed={isCollapsed}
//               $isMobileOpen={isMobileOpen}
//             />
//           </MenuButton>
//           {item.isOpen && (
//             <DropdownMenu
//               $isCollapsed={isCollapsed}
//               $isMobileOpen={isMobileOpen}
//             >
//               {item.items.map((subItem) => (
//                 <li key={subItem.href}>
//                   <MenuButton
//                     asLink
//                     href={subItem.href}
//                     isActive={subItem.active}
//                     className="pl-3"
//                   >
//                     <subItem.icon className="h-4 w-4 flex-shrink-0" />
//                     <span>{subItem.label}</span>
//                   </MenuButton>
//                 </li>
//               ))}
//             </DropdownMenu>
//           )}
//         </li>
//       );
//     }
//   };

//   const userRole = getRole(user?.userRole);
//   const userType = getUserType(user?.userType);

//   const SidebarFooter = () => {
//     return (
//       <FooterContainer>
//         {/* User Info Section */}
//         <div className="flex justify-between p-1.5 rounded-lg bg-gray-50">

//           <UserInfoContainer>
//             <UserAvatar>
//               <FaUser className="h-4 w-4" />
//             </UserAvatar>
//             {(!isCollapsed || isMobileOpen) && (
//               <UserDetails>
//                 <UserName>{user?.name ? capitalizeFirstLetter(user?.name) : "User"}</UserName>
//                 {user.userRoler ?
//                   <UserRole>{userRole}</UserRole> :
//                   <UserRole>{userType}</UserRole>}
//               </UserDetails>
//             )}
//           </UserInfoContainer>

//           {/* Logout Button */}
//           <button className="flex justify-end items-center w-1/4" onClick={onLogoutClick}>
//             <MdLogout className="h-4 w-4 flex-shrink-0 text-rose-500" title="Logout" />
//           </button>
//         </div>
//       </FooterContainer>
//     );
//   };

//   return (
//     <>
//       <MobileMenuButton
//         className="mobile-menu-button"
//         onClick={toggleMobileSidebar}
//       >
//         {isMobileOpen ? <MdClose className="h-5 w-5" /> : <MdMenu className="h-5 w-5" />}
//       </MobileMenuButton>

//       {isMobileOpen && (
//         <MobileOverlay onClick={() => setIsMobileOpen(false)} />
//       )}

//       <SidebarContainer
//         $isCollapsed={isCollapsed}
//         $isMobileOpen={isMobileOpen}
//       >
//         <SidebarHeader>
//           <div className="flex items-center">
//             {(!isCollapsed || isMobileOpen) && (
//               <div className="flex items-center">
//                 <Logo src={Images.Logo} alt="Kipinn Logo" />
//               </div>
//             )}
//           </div>

//           <MobileCloseButton
//             onClick={() => setIsMobileOpen(false)}
//           >
//             <MdClose className="h-4 w-4" />
//           </MobileCloseButton>
//         </SidebarHeader>

//         <SidebarContent>
//           <SidebarNav>
//             <SidebarMenu>
//               {safeMenuItems.map(renderMenuItem)}
//             </SidebarMenu>
//           </SidebarNav>
//         </SidebarContent>
//         <SidebarFooter />

//       </SidebarContainer>
//     </>
//   );
// };

// // Styled Components
// const MobileMenuButton = tw.button`lg:hidden fixed top-3 left-4 z-10 p-2 bg-white rounded-lg shadow-lg border border-gray-200 text-gray-600 hover:bg-gray-100`;
// const MobileOverlay = tw.div`lg:hidden fixed inset-0 bg-black bg-opacity-50 z-5 transition-opacity duration-300`;
// const SidebarContainer = tw.div`no-scrollbar sidebar-container flex flex-col bg-white transition-all duration-300 h-screen z-10 ${props => props.$isCollapsed ? 'w-16' : 'w-60'} lg:static lg:translate-x-0 lg:shadow-none fixed top-0 left-0 ${props => props.$isMobileOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:w-16' : ''}`;
// const SidebarHeader = tw.div`sidebar-header flex items-center justify-between p-4 min-h-16`;
// const Logo = tw.img`w-20`;
// const MobileCloseButton = tw.button`lg:hidden flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 bg-transparent text-gray-600 cursor-pointer transition-all duration-200 hover:bg-gray-100 hover:text-gray-900`;
// const SidebarContent = tw.div`sidebar-content flex-1 overflow-y-auto p-2 no-scrollbar`;
// const SidebarNav = tw.nav`sidebar-nav h-full`;
// const SidebarMenu = tw.ul`sidebar-menu list-none p-0 m-0`;
// const SidebarFooter = tw.div`sidebar-footer p-4 border-t border-gray-200 min-h-16`;
// const MenuButtonWrapper = tw.button`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
// const MenuLink = tw(Link)`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
// const DropdownIcon = tw(MdKeyboardArrowDown)`h-4 w-4 transition-transform ${props => props.$isOpen ? "rotate-180" : ""} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
// const DropdownMenu = tw.ul`ml-4 mt-1 space-y-1 border-l-2 border-gray-200 pl-3 ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
// const MenuItemLabel = tw.span`${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
// const MenuIcon = tw.div`h-4 w-4 flex-shrink-0`;

// const FooterContainer = tw.div`p-4 border-t border-gray-200`;
// const UserInfoContainer = tw.div`flex items-center gap-3 w-3/4`;
// const UserAvatar = tw.div`flex items-center justify-center w-8 h-8 rounded-full bg-primary-color text-white flex-shrink-0`;
// const UserDetails = tw.div`flex flex-col min-w-0`;
// const UserName = tw.span`text-sm font-medium text-gray-900 truncate`;
// const UserRole = tw.span`text-xs text-gray-500 truncate`;

// export default SideNabar;